/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  getYouthAdvisoryCouncil,
  postYouthAdvisoryCouncil
} from '@redux/program-activities/youthadvisorycouncil/actions';
import { getAnnualReportsDashboardOverviewData } from '@redux/annualReport-overview/actions';

import { AssociationAdminLoginDetailsSelector } from '@redux/login/selectors';
import { GetYouthAdvisoryCouncilSelector } from '@redux/program-activities/youthadvisorycouncil/selectors';

import { APP_LABELS, FIELD_LENGTH } from '@config/app-config';
import TextError from '@modules/shared/components/reusable-components/text-error';
import SuccessToaster from '@modules/shared/components/reusable-components/success-toaster';
import PartialSaveWarningPopup from '@modules/shared/components/reusable-components/partial-save-popup';
import LastUpdateName from '../last-update-name';
import FeedbackModal from '../../../../../utilities/feedback-modal';

const YouthAdvisoryCouncilTab = props => {
  const {
    handleGetYouthAdvisoryCouncil,
    GetYouthAdvisoryCouncilSelectorData,
    setLoader,
    handlePostYouthAdvisoryCouncil,
    selectedAsso,
    selectedBranch,
    selectedBranchName,
    setErrorPopup,
    setErrorMessage,
    status,
    role,
    handleGetAnnualReportsDashboard,
    LoginUserData
  } = props;

  const selectedYear = sessionStorage.getItem('selectedBatchYear');
  const sectionName =
    selectedYear >= '2023'
      ? 'Programs and Activities'
      : 'Program and Activities';

  const [isSuccess, setIsSuccess] = useState(false);
  const [resStatus, setResStatus] = useState();
  const [feedbackPopup, setFeedbackPopup] = useState(false);
  const [formId, setFormId] = useState();

  const associateData = JSON.parse(
    sessionStorage.getItem('yusa_selected_associate')
  );

  const formikref = useRef();
  const associationNumber =
    role === APP_LABELS.YUSA_DATA_STEWARD ||
    role === APP_LABELS.YUSA_DATA_VIEWER ||
    role === APP_LABELS.ALLIANCE_DATA_STEWARD ||
    role === APP_LABELS.YESS_DATA_STEWARD
      ? get(associateData, 'associationNumber', '')
      : get(LoginUserData, 'user.associations[0]', 0);

  const handleGetYouthAdvisoryCouncilData = successpopup => {
    if (selectedAsso && selectedBranch) {
      setLoader(true);
      handleGetYouthAdvisoryCouncil(selectedAsso, selectedBranch).then(res => {
        if (res.status === 200) {
          setLoader(false);
          if (successpopup) {
            setIsSuccess(true);
          }
        } else {
          setLoader(false);
          setErrorMessage(APP_LABELS.COMMON_ERROR_MESSAGE);
          setErrorPopup(true);
        }
      });
    }
  };

  useEffect(() => {
    handleGetYouthAdvisoryCouncilData();
    formikref?.current?.resetForm();
  }, [selectedAsso, selectedBranch]);

  const initialValues = {
    hasYouthAdvisoryCouncil: '',
    youngestAge: '',
    largestAge: '',
    councilMemberCount: '',
    councilAdvisoryAreas: [],
    hasBoardMembersUnder25: '',
    hasVotingPower: ''
  };

  const editValues = {
    hasYouthAdvisoryCouncil:
      GetYouthAdvisoryCouncilSelectorData?.data?.hasYouthAdvisoryCouncil ===
      null
        ? ''
        : `${GetYouthAdvisoryCouncilSelectorData?.data?.hasYouthAdvisoryCouncil}`,
    youngestAge: GetYouthAdvisoryCouncilSelectorData?.data
      ?.hasYouthAdvisoryCouncil
      ? GetYouthAdvisoryCouncilSelectorData?.data?.youngestAge
      : null,
    largestAge: GetYouthAdvisoryCouncilSelectorData?.data
      ?.hasYouthAdvisoryCouncil
      ? GetYouthAdvisoryCouncilSelectorData?.data?.largestAge
      : null,
    councilMemberCount: GetYouthAdvisoryCouncilSelectorData?.data
      ?.hasYouthAdvisoryCouncil
      ? GetYouthAdvisoryCouncilSelectorData?.data?.councilMemberCount
      : null,
    councilAdvisoryAreas: GetYouthAdvisoryCouncilSelectorData?.data
      ?.hasYouthAdvisoryCouncil
      ? GetYouthAdvisoryCouncilSelectorData?.data?.councilAdvisoryAreas
          ?.split(', ')
          .map(item => item.trim())
      : [],
    // GetYouthAdvisoryCouncilSelectorData?.data?.councilAdvisoryAreas,
    hasBoardMembersUnder25:
      GetYouthAdvisoryCouncilSelectorData?.data?.hasBoardMembersUnder25 === null
        ? ''
        : `${GetYouthAdvisoryCouncilSelectorData?.data?.hasBoardMembersUnder25}`,
    hasVotingPower:
      GetYouthAdvisoryCouncilSelectorData?.data?.hasBoardMembersUnder25 === true
        ? GetYouthAdvisoryCouncilSelectorData?.data?.hasVotingPower === null
          ? ''
          : `${GetYouthAdvisoryCouncilSelectorData?.data?.hasVotingPower}`
        : null
  };

  const validationSchema = Yup.object({
    hasYouthAdvisoryCouncil: Yup.string().nullable(),
    youngestAge: Yup.string().nullable(),
    largestAge: Yup.string().nullable(),
    councilMemberCount: Yup.string().nullable(),
    councilAdvisoryAreas: Yup.array(),
    hasBoardMembersUnder25: Yup.string().nullable(),
    hasVotingPower: Yup.string().nullable()
  });

  const onSubmit = values => {
    setLoader(true);
    const payloadBody = {
      programActivityYouthAdvisoryCouncilId:
        GetYouthAdvisoryCouncilSelectorData?.data
          ?.programActivityYouthAdvisoryCouncilId,
      associationNumber: selectedAsso,
      branchNumber: selectedBranch,
      branchName: selectedBranchName?.toString(),
      year: sessionStorage.getItem('selectedBatchYear'),

      hasYouthAdvisoryCouncil:
        values?.hasYouthAdvisoryCouncil === ''
          ? null
          : values?.hasYouthAdvisoryCouncil === 'true',
      youngestAge:
        values?.hasYouthAdvisoryCouncil === 'true' && values?.youngestAge !== ''
          ? values?.youngestAge
          : null,
      largestAge:
        values?.hasYouthAdvisoryCouncil === 'true' && values?.largestAge !== ''
          ? values?.largestAge
          : null,
      councilMemberCount:
        values?.hasYouthAdvisoryCouncil === 'true' &&
        values?.councilMemberCount !== ''
          ? values?.councilMemberCount
          : null,
      councilAdvisoryAreas:
        values?.hasYouthAdvisoryCouncil === 'true'
          ? `${values?.councilAdvisoryAreas?.join(', ')}`
          : null,
      hasBoardMembersUnder25:
        values?.hasBoardMembersUnder25 === ''
          ? null
          : values?.hasBoardMembersUnder25 === 'true',
      hasVotingPower:
        values?.hasVotingPower === null
          ? null
          : values?.hasVotingPower === 'true',

      status: GetYouthAdvisoryCouncilSelectorData?.data?.status,
      reportBatchId: GetYouthAdvisoryCouncilSelectorData?.data?.reportBatchId,
      createdByPersonId:
        GetYouthAdvisoryCouncilSelectorData?.data?.createdByPersonId,
      createdByName: GetYouthAdvisoryCouncilSelectorData?.data?.createdByName,
      createdDatetime:
        GetYouthAdvisoryCouncilSelectorData?.data?.createdDatetime,
      updatedByPersonId:
        GetYouthAdvisoryCouncilSelectorData?.data?.updatedByPersonId,
      updatedByName: GetYouthAdvisoryCouncilSelectorData?.data?.updatedByName,
      updatedDatetime:
        GetYouthAdvisoryCouncilSelectorData?.data?.updatedDatetime
    };

    setIsSuccess(false);
    handlePostYouthAdvisoryCouncil(payloadBody).then(res => {
      handleGetYouthAdvisoryCouncilData(true);
      if (res?.data?.isSuccess) {
        setResStatus(res?.data?.data?.recordStatus);
        handleGetAnnualReportsDashboard(associationNumber, selectedYear).then(
          dashData => {
            dashData?.data?.data?.dashboardDTOs?.forEach(record => {
              if (
                record.name === sectionName &&
                record.status === 'Completed' &&
                record.rating === null &&
                selectedYear >= '2023' &&
                role !== APP_LABELS.YUSA_DATA_STEWARD &&
                role !== APP_LABELS.YESS_DATA_STEWARD
              ) {
                setFeedbackPopup(true);
                setFormId(record?.formId);
                setLoader(false);
              }
            });
          }
        );
      } else {
        setLoader(false);
        setErrorMessage(res?.message);
        setErrorPopup(true);
      }
    });
  };

  const scrollToErrors = errors => {
    const errorKeys = Object.keys(errors);
    if (errorKeys.length > 0) {
      document.getElementsByName(errorKeys[0])[0].focus();
    }
  };

  const handleChange = (e, setFieldValue, name) => {
    const result = e.target.value.replace(/\D+/g, '');
    setFieldValue(name, result);
  };

  return (
    <>
      <Formik
        innerRef={formikref}
        initialValues={editValues || initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ values, dirty, errors, setFieldValue }) => {
          sessionStorage.setItem('dirty', dirty);
          return (
            <Form>
              <div className="ymca-program pt-1">
                <div className="mt-1">
                  {GetYouthAdvisoryCouncilSelectorData?.data?.recordStatus?.toUpperCase() ===
                    APP_LABELS.STATUS_PARTIAL && <PartialSaveWarningPopup />}
                </div>

                <div className="ymca-covidRelif pt-0 ps-0">
                  <h4 className="ymca-headingTitle  txt-mandatory">
                    Does your Y have a youth/teen advisory council?
                  </h4>
                  <div className="ymca-radioBTN d-flex pb-0">
                    <div className="me-5">
                      <Field
                        type="radio"
                        name="hasYouthAdvisoryCouncil"
                        className="me-2"
                        value="true"
                      />
                      <span>Yes</span>
                    </div>
                    <div className="">
                      <Field
                        type="radio"
                        name="hasYouthAdvisoryCouncil"
                        className="me-2"
                        value="false"
                      />
                      <span>No</span>
                    </div>
                  </div>
                </div>
                <ErrorMessage
                  component={TextError}
                  name="hasYouthAdvisoryCouncil"
                />
                {values.hasYouthAdvisoryCouncil === 'true' && (
                  <>
                    <div className="ymca-covidRelif pt-0 ps-0">
                      <h4 className="ymca-headingTitle  txt-mandatory">
                        Please enter the age requirements to be a member of the
                        council with the youngest age in the first box and
                        largest age in the second box.
                      </h4>
                      <div className="ymca-radioBTN d-flex pb-0">
                        <div className="ymca-selectWrap me-5">
                          <Field
                            type="text"
                            className="ymca-fieldSet"
                            name="youngestAge"
                            onChange={e =>
                              handleChange(e, setFieldValue, 'youngestAge')
                            }
                            maxLength={2}
                          />
                        </div>
                        <div className="ymca-headingTitle me-5">
                          <span>-</span>
                        </div>
                        <div className="ymca-selectWrap">
                          <Field
                            type="text"
                            className="ymca-fieldSet"
                            name="largestAge"
                            onChange={e =>
                              handleChange(e, setFieldValue, 'largestAge')
                            }
                            maxLength={2}
                          />
                        </div>
                      </div>
                      {values?.youngestAge > values?.largestAge && (
                        <div className="errorNote mb-2">
                          * first box value should be less than second box value
                        </div>
                      )}
                    </div>

                    <div className="ymca-covidRelif pt-0 ps-0">
                      <h4 className="ymca-headingTitle  txt-mandatory">
                        How many members are currently on your advisory council?
                      </h4>
                      <div className="ymca-radioBTN d-flex pb-0">
                        <div className="me-5">
                          <div className="ymca-selectWrap">
                            <Field
                              type="text"
                              className="ymca-fieldSet"
                              name="councilMemberCount"
                              onChange={e =>
                                handleChange(
                                  e,
                                  setFieldValue,
                                  'councilMemberCount'
                                )
                              }
                              maxLength={FIELD_LENGTH.TEXTBOX_LENGTH}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="ymca-covidRelif pt-0 ps-0">
                      <h4 className="ymca-headingTitle form-group txt-mandatory ">
                        Please select the areas on which the council advises.
                      </h4>

                      <div className="row">
                        <div className="col-4">
                          <span className="ymca-normalWrap ymca-checkboxers">
                            <div className="d-flex ymca-listingERA">
                              <input
                                type="checkbox"
                                className="ymca-checkBox"
                              />
                              <Field
                                name="councilAdvisoryAreas"
                                id="programDevelopmentCouncilAdvises"
                                type="checkbox"
                                className="styled-checkbox"
                                value="Program development"
                              />
                              <label htmlFor="programDevelopmentCouncilAdvises" />
                              <span className="ymca-texting">
                                Program development
                              </span>
                            </div>
                          </span>

                          <span className="ymca-normalWrap ymca-checkboxers">
                            <div className="d-flex ymca-listingERA">
                              <input
                                type="checkbox"
                                className="ymca-checkBox"
                              />
                              <Field
                                name="councilAdvisoryAreas"
                                id="strategicPlanningCouncilAdvises"
                                type="checkbox"
                                className="styled-checkbox"
                                value="Strategic planning"
                              />
                              <label htmlFor="strategicPlanningCouncilAdvises" />
                              <span className="ymca-texting">
                                Strategic planning
                              </span>
                            </div>
                          </span>

                          <span className="ymca-normalWrap ymca-checkboxers">
                            <div className="d-flex ymca-listingERA">
                              <input
                                type="checkbox"
                                className="ymca-checkBox"
                              />
                              <Field
                                name="councilAdvisoryAreas"
                                id="advocacyOutreachCouncilAdvises"
                                type="checkbox"
                                className="styled-checkbox"
                                value="Advocacy and outreach"
                              />
                              <label htmlFor="advocacyOutreachCouncilAdvises" />
                              <span className="ymca-texting">
                                Advocacy and outreach
                              </span>
                            </div>
                          </span>

                          <span className="ymca-normalWrap ymca-checkboxers">
                            <div className="d-flex ymca-listingERA">
                              <input
                                type="checkbox"
                                className="ymca-checkBox"
                              />
                              <Field
                                name="councilAdvisoryAreas"
                                id="eventPlanningParticipationCouncilAdvises"
                                type="checkbox"
                                className="styled-checkbox"
                                value="Event planning and participation"
                              />
                              <label htmlFor="eventPlanningParticipationCouncilAdvises" />
                              <span className="ymca-texting">
                                Event planning and participation
                              </span>
                            </div>
                          </span>
                        </div>

                        <div className="col-4">
                          <span className="ymca-normalWrap ymca-checkboxers">
                            <div className="d-flex ymca-listingERA">
                              <input
                                type="checkbox"
                                className="ymca-checkBox"
                              />
                              <Field
                                name="councilAdvisoryAreas"
                                id="leadershipDevelopmentCouncilAdvises"
                                type="checkbox"
                                className="styled-checkbox"
                                value="Leadership development"
                              />
                              <label htmlFor="leadershipDevelopmentCouncilAdvises" />
                              <span className="ymca-texting">
                                Leadership development
                              </span>
                            </div>
                          </span>

                          <span className="ymca-normalWrap ymca-checkboxers">
                            <div className="d-flex ymca-listingERA">
                              <input
                                type="checkbox"
                                className="ymca-checkBox"
                              />
                              <Field
                                name="councilAdvisoryAreas"
                                id="marketingCommunicationsCouncilAdvises"
                                type="checkbox"
                                className="styled-checkbox"
                                value="Marketing and communications"
                              />
                              <label htmlFor="marketingCommunicationsCouncilAdvises" />
                              <span className="ymca-texting">
                                Marketing and communications
                              </span>
                            </div>
                          </span>

                          <span className="ymca-normalWrap ymca-checkboxers">
                            <div className="d-flex ymca-listingERA">
                              <input
                                type="checkbox"
                                className="ymca-checkBox"
                              />
                              <Field
                                name="councilAdvisoryAreas"
                                id="financialDevelopmentCouncilAdvises"
                                type="checkbox"
                                className="styled-checkbox"
                                value="Financial development"
                              />
                              <label htmlFor="financialDevelopmentCouncilAdvises" />
                              <span className="ymca-texting">
                                Financial development
                              </span>
                            </div>
                          </span>

                          <span className="ymca-normalWrap ymca-checkboxers">
                            <div className="d-flex ymca-listingERA">
                              <input
                                type="checkbox"
                                className="ymca-checkBox"
                              />
                              <Field
                                name="councilAdvisoryAreas"
                                id="researchCouncilAdvises"
                                type="checkbox"
                                className="styled-checkbox"
                                value="Research"
                              />
                              <label htmlFor="researchCouncilAdvises" />
                              <span className="ymca-texting">Research</span>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div className="ymca-covidRelif pt-0 ps-0">
                  <h4 className="ymca-headingTitle  txt-mandatory">
                    Do you have any Association Board members under the age of
                    25?
                  </h4>
                  <div className="ymca-radioBTN d-flex pb-0">
                    <div className="me-5">
                      <Field
                        type="radio"
                        name="hasBoardMembersUnder25"
                        className="me-2"
                        value="true"
                      />
                      <span>Yes</span>
                    </div>
                    <div className="">
                      <Field
                        type="radio"
                        name="hasBoardMembersUnder25"
                        className="me-2"
                        value="false"
                      />
                      <span>No</span>
                    </div>
                  </div>
                </div>
                <ErrorMessage
                  component={TextError}
                  name="hasBoardMembersUnder25"
                />
                {values.hasBoardMembersUnder25 === 'true' && (
                  <>
                    <div className="ymca-covidRelif pt-0 ps-0">
                      <h4 className="ymca-headingTitle  txt-mandatory">
                        Do they have voting power?
                      </h4>
                      <div className="ymca-radioBTN d-flex pb-0">
                        <div className="me-5">
                          <Field
                            type="radio"
                            name="hasVotingPower"
                            className="me-2"
                            value="true"
                          />
                          <span>Yes</span>
                        </div>
                        <div className="">
                          <Field
                            type="radio"
                            name="hasVotingPower"
                            className="me-2"
                            value="false"
                          />
                          <span>No</span>
                        </div>
                      </div>
                    </div>
                    <ErrorMessage component={TextError} name="hasVotingPower" />
                  </>
                )}

                <div className="ymca-submitHighlighter">
                  <LastUpdateName
                    Username={
                      GetYouthAdvisoryCouncilSelectorData?.data?.updatedByName
                    }
                    Time={
                      GetYouthAdvisoryCouncilSelectorData?.data?.updatedDatetime
                    }
                  />
                </div>
                {role !== APP_LABELS.YUSA_DATA_VIEWER &&
                  role !== APP_LABELS.ALLIANCE_DATA_STEWARD && (
                    <button
                      type="submit"
                      className="btn ymca-savingBTN ymca-btnRightUntitledUnderLay float-end"
                      onClick={() => scrollToErrors(errors)}
                      disabled={
                        status?.toUpperCase() === APP_LABELS.STATUS_SUBMITTED
                      }
                    >
                      Save
                    </button>
                  )}
              </div>
              {isSuccess && <SuccessToaster Status={resStatus} />}
            </Form>
          );
        }}
      </Formik>

      <FeedbackModal
        handleCloseFeedbackPopup={() => {
          setFeedbackPopup(false);
        }}
        showFeedbackPopup={feedbackPopup}
        sectionName={sectionName}
        selectedYear={selectedYear}
        associationNumber={associationNumber}
        formId={formId}
      />
    </>
  );
};

YouthAdvisoryCouncilTab.propTypes = {
  handleGetYouthAdvisoryCouncil: PropTypes.func.isRequired,
  handlePostYouthAdvisoryCouncil: PropTypes.func.isRequired,
  GetYouthAdvisoryCouncilSelectorData: PropTypes.objectOf(PropTypes.any)
    .isRequired,
  setLoader: PropTypes.func.isRequired,
  selectedAsso: PropTypes.objectOf(PropTypes.any).isRequired,
  selectedBranch: PropTypes.objectOf(PropTypes.any).isRequired,
  selectedBranchName: PropTypes.objectOf(PropTypes.any).isRequired,
  setErrorPopup: PropTypes.func.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
  status: PropTypes.objectOf(PropTypes.any).isRequired,
  role: PropTypes.objectOf(PropTypes.any).isRequired,
  handleGetAnnualReportsDashboard: PropTypes.func.isRequired,
  LoginUserData: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapDispatchToProps = {
  handlePostYouthAdvisoryCouncil: postYouthAdvisoryCouncil,
  handleGetYouthAdvisoryCouncil: getYouthAdvisoryCouncil,
  handleGetAnnualReportsDashboard: getAnnualReportsDashboardOverviewData
};

const mapStateToProps = state => ({
  GetYouthAdvisoryCouncilSelectorData: GetYouthAdvisoryCouncilSelector(state),
  LoginUserData: AssociationAdminLoginDetailsSelector(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(YouthAdvisoryCouncilTab));
